import { useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Header } from "./Header";
import { MessageList } from "./MessageList";
import { MessageInput } from "./MessageInput";
import { AppState } from "../store/definitions";
import { ConversationEnded } from "./ConversationEnded";
import { NotificationBar } from "./NotificationBar";
import { removeNotification } from "../store/actions/genericActions";
import { notifications } from "../notifications";
import { AttachFileDropArea } from "./AttachFileDropArea";
import { isHumanMode } from "../store/selectors";

export const MessagingCanvasPhase = () => {
    const dispatch = useDispatch();
    const conversationState = useSelector((state: AppState) => state.chat.conversationState);
    const humanMode = useSelector((state: AppState) => isHumanMode(state.chat));

    useEffect(() => {
        dispatch(removeNotification(notifications.failedToInitSessionNotification("ds").id));
    }, [dispatch]);

    /*
     * Despedida (ConversationEnded): no `closed` real sempre; no `inactive` (timer AFK de 5 min)
     * só na fase de IA. Em humanMode, o `inactive` é ignorado — o synccx-api estende o Timers.Inactive
     * no transbordo, mas este guard garante que o atendimento humano nunca é cortado pelo timer,
     * independente do backend (defesa em profundidade).
     */
    const conversationEnded = conversationState === "closed" || (conversationState === "inactive" && !humanMode);

    const Wrapper = conversationEnded ? Fragment : AttachFileDropArea;

    return (
        <Wrapper>
            <Header />
            <NotificationBar />
            <MessageList />
            {conversationEnded ? <ConversationEnded /> : <MessageInput />}
        </Wrapper>
    );
};
